import { render } from "./ServicesComponent.vue?vue&type=template&id=6254e9a7&scoped=true"
const script = {}

import "./ServicesComponent.vue?vue&type=style&index=0&id=6254e9a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6254e9a7"]])

export default __exports__